var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexcharts',{attrs:{"options":_vm.chartOptionsComputed,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }